import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxTreePopup = _resolveComponent("DxTreePopup")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxPatternRule = _resolveComponent("DxPatternRule")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxRowDragging = _resolveComponent("DxRowDragging")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxTreeButton = _resolveComponent("DxTreeButton")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxTreeList = _resolveComponent("DxTreeList")!

  return (_openBlock(), _createBlock(_component_DxTreeList, {
    ref: "treeListRef",
    "data-source": _ctx.dsAgenti,
    "key-expr": "Id",
    "parent-id-expr": "ParinteID",
    "root-value": null,
    "show-borders": false,
    "row-alternation-enabled": true,
    "column-auto-width": true,
    "auto-expand-all": true,
    "hover-state-enabled": true,
    "word-wrap-enabled": true,
    onInitNewRow: _ctx.onInitNewRow
  }, {
    editTitle: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px 0 10px 20px","width":"100%"} }, " Editare Agent ", -1)
    ]))]),
    numeTemplate: _withCtx(({ data: cellInfo }) => [
      cellInfo
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (cellInfo.row.node && cellInfo.row.node.hasChildren)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "🧑‍🧒‍🧒 "))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "👤 ")),
            _createElementVNode("span", null, _toDisplayString(cellInfo.text), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DxToolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_DxItem, { name: "addRowButton" }),
          _createVNode(_component_DxItem, { name: "searchPanel" })
        ]),
        _: 1
      }),
      _createVNode(_component_DxEditing, {
        "allow-adding": true,
        "allow-deleting": true,
        "allow-updating": true,
        mode: "popup",
        texts: {
            confirmDeleteMessage: 'Sigur doriți să ștergeți această înregistrare?',
            confirmDeleteTitle: 'Confirmare Ștergere'
        }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxTreePopup, {
            closeOnOutsideClick: false,
            showCloseButton: false,
            width: "400px",
            height: "580px",
            "show-title": true,
            "title-template": "editTitle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxToolbarItem, {
                toolbar: "bottom",
                widget: "dxButton",
                location: "center",
                options: _ctx.saveButtonOptions
              }, null, 8, ["options"]),
              _createVNode(_component_DxToolbarItem, {
                toolbar: "bottom",
                widget: "dxButton",
                location: "center",
                options: _ctx.dangerButtonOptions
              }, null, 8, ["options"])
            ]),
            _: 1
          }),
          _createVNode(_component_DxForm, { "col-count": 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                "data-field": "Nume",
                "editor-options": { height: 50 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Numele este obligatoriu!" })
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, {
                "data-field": "Cod",
                "editor-options": { height: 50 }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "Descriere",
                "editor-options": { height: 50 }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "Email",
                "editor-options": { height: 50 }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "Tel",
                "editor-options": { height: 50 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxPatternRule, {
                    pattern: "^[0-9]+$",
                    message: "Numărul de telefon trebuie să conțină doar cifre!"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, {
                "data-field": "NotifPartenerInsert",
                "editor-type": "dxCheckBox",
                "css-class": "centered-checkbox",
                label: { text: 'Notificare Agent' },
                "editor-options": { value: false, enableThreeStateBehavior: false }
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DxRowDragging, {
        "on-drag-change": _ctx.onDragChange,
        "on-reorder": _ctx.onReorder,
        "allow-drop-inside-item": true,
        "allow-reordering": true
      }, null, 8, ["on-drag-change", "on-reorder"]),
      _createVNode(_component_DxSearchPanel, {
        visible: true,
        width: 250
      }),
      _createVNode(_component_DxHeaderFilter, { visible: true }),
      _createVNode(_component_DxColumn, { type: "buttons" }, {
        default: _withCtx(() => [
          _createVNode(_component_DxTreeButton, {
            name: "add",
            hint: "Adaugă sub agent"
          }),
          _createVNode(_component_DxTreeButton, { name: "edit" }),
          _createVNode(_component_DxTreeButton, { name: "delete" })
        ]),
        _: 1
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Cod",
        caption: "Cod",
        visible: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Nume",
        caption: "Nume",
        "cell-template": "numeTemplate"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Descriere",
        caption: "Descriere",
        visible: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "ProcentGeneralClienti",
        caption: "Procent General Clienti",
        visible: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "ProcentGeneralRamuri",
        caption: "Procent General Ramuri",
        visible: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Nivel",
        caption: "Nivel"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Email",
        caption: "Email"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "Tel",
        caption: "Telefon"
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "NotifPartenerInsert",
        caption: "Notificare Partener Insert",
        "data-type": "boolean",
        visible: false
      }),
      _createVNode(_component_DxColumn, {
        "data-field": "ParinteID",
        visible: false
      })
    ]),
    _: 1
  }, 8, ["data-source", "onInitNewRow"]))
}